import BlacksmithIcon from "./BlacksmithIcon.mjs";

export default class MyRemediationIcon extends BlacksmithIcon {}
